import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useParams } from "react-router-dom";
import Select from "react-dropdown-select";
import axios from "axios";
import { emit } from "process";
const token = localStorage.getItem('authToken');
class EditDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageInput: [],
      existingImages: [],
      textInput: "",
      id: "",
      refCode: "",
      userName: "",
      emailInput: "",
      state: "",
      city: "",
      pinCode: "",
      bloodGroup: "",
      nativeOf: "",
      district: "",
      kulName: "",
      caste: "",
      subcaste: "",
      gotra: "",
      areaInput: "",
      firmName: "",
      firmAddress: "",
      dealsWith: "",
      contact: "",
      website: "",
      images: [],
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
      errors: [],
      category: "",
      categoryData: [],
      selectedJobCategories: [],
      currentImageUrls: [],
      submissionStatus: null,
      currentImageUrl: null,
      submeet: false,
      gender: "",
      selectedJobCategories: [],
    };
    this.handleBloodDonateChange = this.handleBloodDonateChange.bind(this);
  }

  async componentDidMount() {
    const { match } = this.props;
    const { id } = match.params;
    this.setState({ id });
    this.fetchData(id);
    this.fetchDataOccupation();
  }
  fetchData = async (id) => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/users/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const userData = response?.data;
      console.log(userData)
      this.setState({
        userName: userData?.fullName,
        areaInput: userData.address,
        state: userData.state,
        city: userData.city,
        gender: userData.gender,
        pinCode: userData.pincode,
        bloodGroup: userData.bloodGroup,
        bloodDonate: userData?.bloodYN || '',
        nativeOf: userData.nativeOf,
        district: userData.homeDistrict,
        homeCity: userData.homeCity,
        caste: userData.caste,
        subcaste: userData.subcaste,
        gotra: userData.gotra,
        kulName: userData.kuldeviName,
        firmName: userData.businessProfile.firmName,
        firmAddress: userData.businessProfile.firmAddress,
        dealsWith: userData.businessProfile.dealsWith,
        existingImages: userData.businessProfile?.businessImages,
        contact: userData.contactNo,
        emailInput: userData?.email,
        website: userData.businessProfile.website,
        currentImageUrl: userData.image || '',
        selectedJobCategories: userData.selectedJobCategories,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  fetchDataOccupation = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/occupation`);
      console.log(response.data);
      if (response.data) {
        this.setState({ categoryData: response.data.categories });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  handleNativeOfChange = (e) => {
    const nativeOf = e.target.value;
    this.setState({ nativeOf, district: "", city: "" });
  };

  handleDistrictChange = (e) => {
    const district = e.target.value;
    this.setState({ district, city: "" });
  };

  handleCityChange = (e) => {
    const homeCity = e.target.value;
    this.setState({ homeCity });
  };

  handleCasteChange = (e) => {
    const caste = e.target.value;
    this.setState({ caste, subcaste: "", gotra: "" });
  };

  handleSubcasteChange = (e) => {
    const subcaste = e.target.value;
    this.setState({ subcaste, gotra: "" });
  };

  handleGotraChange = (e) => {
    const gotra = e.target.value;
    this.setState({ gotra });
  };

  handleChange = (e) => {
    const file = e.target.files[0];
    const errors = [];
  
    if (file) {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file),
          errors: [],  // Clear previous errors if the new file is valid
        });
      }
    }
  
    this.setState({ errors });
  };
  

  handleChangeMultipaleImages = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    const selectedImages = files.filter((file) => {
      const isValidSize = file.size <= this.state.maxSize;
      if (!isValidSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      }
      return isValidSize;
    });

    this.setState({
      imageInput: selectedImages,
      currentImageUrls: selectedImages.map((file) => URL.createObjectURL(file)),
      errors,
    });
  };


  

  handleBloodDonateChange(e) {
    this.setState({ bloodDonate: e.target.value });
  }
  handleOccupationChange = (e) => {
    const value = e.target.value;
    this.setState({ selectedJobCategories: [value] });
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.props.match.params;
  
    try {
      const {
        existingImages,
        imageInput,
        textInput,
        refCode,
        emailInput,
        areaInput,
        userName,
        state,
        city,
        pinCode,
        bloodGroup,
        bloodDonate,
        nativeOf,
        district,
        homeCity,
        kulName,
        caste,
        subcaste,
        gotra,
        firmName,
        firmAddress,
        dealsWith,
        contact,
        gender,
        website,
        category,
        selectedJobCategories
      } = this.state;
  
      const formData = new FormData();
  
      // Append new images if available, otherwise append existing images
      if (imageInput.length > 0) {
        imageInput.forEach((file) => {
          formData.append('businessImages', file);
        });
      } else {
        existingImages.forEach((url) => {
          formData.append('existingImages', url);
        });
      }
  
      if (textInput) {
        formData.append('image', textInput);
      }
  
      formData.append('fullName', userName);
      formData.append('email', emailInput);
      formData.append('address', areaInput);
  
      formData.append('state', state);
      formData.append('city', city);
      formData.append('pincode', pinCode);
      formData.append('bloodGroup', bloodGroup);
      formData.append('bloodYN', bloodDonate);
      formData.append('nativeOf', nativeOf);
      formData.append('homeDistrict', district);
      formData.append('homeCity', homeCity);
      formData.append('kuldeviName', kulName);
      formData.append('caste', caste);
      formData.append('subcaste', subcaste);
      formData.append('gotra', gotra);
      formData.append('businessProfile.firmName', firmName);
      formData.append('businessProfile.firmAddress', firmAddress);
      formData.append('businessProfile.dealsWith', dealsWith);
      formData.append('contactNo', contact);
      formData.append('businessProfile.website', website);
      formData.append('selectedJobCategories[]', selectedJobCategories);
      formData.append('gender', gender);
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };
  
      const response = await axios.put(`https://samaj.aasmo.in/api/admin/users/${id}`, formData, config);
  
      if (response.status === 200) {
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
       this.props.history.push("/tablenormal");
        }, 2000);
      }
  
      console.log(response, "==>res");
    } catch (error) {
      console.log(error);
    }
  };
  
 




  render() {
    const { textInput, emailInput,gender, existingImages, errors, imageInput, areaInput, category, selectedJobCategories, categoryData, submeet, userName, currentImageUrls, state, city, pinCode, bloodGroup, nativeOf, district, kulName, caste, subcaste, gotra, firmName, firmAddress, dealsWith, contact, website, bloodDonate, homeCity, submissionStatus
    } = this.state;
    const reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Directory Member</h2>
          </div>
          <div className="body">
            <form className="ng-untouched ng-dirty ng-invalid">

            <div className="form-group">
  <label>Profile Photo</label>

  {this.state.currentImageUrl && (
    <div>
      <img
        src={`https://uma-classees.blr1.digitaloceanspaces.com/${this.state.currentImageUrl}`}
        alt="Current"
        style={{ width: '100px', marginBottom: '10px' }}
      />
    </div>
  )}

  <input
    type="file"
    className={`form-control ${!this.state.textInput && this.state.submeet && "parsley-error"}`}
    name="textInput"
    required=""
    onChange={this.handleChange}
  />

  {!this.state.textInput && this.state.submeet ? (
    <ul className="parsley-errors-list filled">
      <li className="parsley-required">This value is required.</li>
    </ul>
  ) : null}
</div>


              {/* <div className="form-group">
                <label>Profile Photo</label>
                <input
                  type="file"
                  className={`form-control ${textInput === "" && submeet && "parsley-error"
                    }`}
                  // value={textInput}
                  name="textInput"
                  required=""
                  onChange={(e) => {
                    this.setState({
                      textInput: e.target.files[0], // Store the file itself
                      submeet: true, // Set submeet to true when changing the file
                    });
                    
                 
                  }}
                />
                {textInput === "" && submeet ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div> */}

              <div className="form-group">
                <label>Name</label>
                <input
                  className={`form-control ${!reg.test(userName) && submeet && "parsley-error"
                    }`}
                  value={userName}
                  name="userName"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                  required=""
                  type="text"
                  //   onChange={this.handleChange}
                  onChange={(e) => {
                    this.setState({ userName: e.target.value });
                  }}
                />
                {submeet && !reg.test(userName) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Contact No :</label>
                <input
                  className={`form-control ${!reg.test(contact) && submeet && "parsley-error"
                    }`}
                  value={contact}
                  name="contact"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                  required=""
                  type="number"
                  onChange={(e) => {
                    this.setState({ contact: e.target.value });
                  }}
                />
                {submeet && !reg.test(contact) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
      <label>Gender</label>
      <select
        className={`form-control ${submeet && !gender && "parsley-error"}`}
        value={gender}
        name="gender"
        required=""
        onChange={(e) => {
          this.setState({ gender: e.target.value });
        }}
      >
        <option value="">Select Gender</option>
        <option value="Male">Male</option>
        <option value="Female">Female</option>
        <option value="Other">Other</option>
      </select>
      {submeet && !gender ? (
        <ul className="parsley-errors-list filled" id="parsley-id-29">
          <li className="parsley-required">Gender is required.</li>
        </ul>
      ) : null}
    </div>
              <div className="form-group">
                <label>Email :</label>
                <input
                  className={`form-control ${!reg.test(emailInput) && submeet && "parsley-error"
                    }`}
                  value={emailInput}
                  name="emailInput"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                  required=""
                  type="email"
                  onChange={(e) => {
                    this.setState({ emailInput: e.target.value });
                  }}
                />
                {submeet && !reg.test(emailInput) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Current Address</label>
                <textarea
                  className={`form-control ${areaInput === "" && submeet && "parsley-error"
                    }`}
                  value={areaInput}
                  cols="30"
                  name="textarea"
                  required=""
                  rows="5"
                  onChange={(e) => {
                    this.setState({ areaInput: e.target.value });
                  }}
                ></textarea>
                {areaInput === "" && submeet ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Current State</label>
                <input
                  className={`form-control ${!reg.test(state) && submeet && "parsley-error"
                    }`}
                  value={state}
                  name="state"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ state: e.target.value });
                  }}
                />
                {submeet && !reg.test(state) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>City</label>
                <input
                  className={`form-control ${!reg.test(city) && submeet && "parsley-error"
                    }`}
                  value={city}
                  name="city"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ city: e.target.value });
                  }}
                />
                {submeet && !reg.test(city) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>


              <div className="form-group">
                <label>Pincode</label>
                <input
                  type="number"
                  className={`form-control ${pinCode === "" && submeet && "parsley-error"
                    }`}
                  value={pinCode}
                  name="number"
                  required=""
                  onChange={(e) => {
                    this.setState({
                      pinCode: e.target.value,
                      submeet: false,
                    });
                  }}
                />
                {pinCode === "" && submeet ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label htmlFor="bloodGroup">Blood Group</label>
                <select
                  className={`form-control ${submeet && !bloodGroup && "parsley-error"
                    }`}
                  value={bloodGroup}
                  name="bloodGroup"
                  required=""
                  onChange={(e) => {
                    this.setState({ bloodGroup: e.target.value });
                  }}
                >
                  <option value="">{bloodGroup}</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                </select>
                {submeet && !bloodGroup ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Blood group is required.</li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Are you interested in donating blood Y/N</label>
                <br />
                <label className="fancy-radio">
                  <input
                    data-parsley-errors-container="#error-radio"
                    name="bloodDonate"
                    required
                    type="radio"
                    value="yes"
                    onChange={this.handleBloodDonateChange}
                    checked={bloodDonate === 'yes'}
                  />
                  <span>
                    <i></i>Yes
                  </span>
                </label>
                <label className="fancy-radio">
                  <input
                    name="bloodDonate"
                    type="radio"
                    value="no"
                    onChange={this.handleBloodDonateChange}
                    checked={bloodDonate === 'no'}
                  />
                  <span>
                    <i></i>NO
                  </span>
                </label>
              </div>
              <div className="form-group">
                <label>Native of</label>
                <select
                  className="form-control"
                  value={nativeOf}
                  name="nativeOf"
                  required=""
                  onChange={this.handleNativeOfChange}
                >
                  <option value="">{nativeOf}</option>
                  <option value="Haryana">Haryana</option>
                  <option value="Rajasthan">Rajasthan</option>
                </select>
              </div>

              {/* Home District dropdown */}
              {nativeOf && (
                <div className="form-group">
                  <label>Home District</label>
                  <select
                    className="form-control"
                    value={district}
                    name="district"
                    required=""
                    onChange={this.handleDistrictChange}
                  >
                    <option value="">{district}</option>
                    {nativeOf === "Haryana" ? (
                      <>
                        <option value="District 1">Ambala</option>
                        <option value="District 2">Bhiwani</option>

                      </>
                    ) : nativeOf === "Rajasthan" ? (
                      <>
                        <option value="District A">Jaipur</option>
                        <option value="District B">Udaipur</option>
                      </>
                    ) : null}
                  </select>
                </div>
              )}

              {/* Home City dropdown */}
              {district && (
                <div className="form-group">
                  <label>Home City</label>
                  <select
                    className="form-control"
                    value={homeCity}
                    name="homeCity"
                    required=""
                    onChange={this.handleCityChange}
                  >
                    <option value="">{homeCity}</option>
                    {/* Render options based on selected district */}
                    {district === "District 1" ? (
                      <>
                        <option value="City 1">Babiyal</option>
                        {/* <option value="City 2">Loharu</option> */}
                      </>
                    ) : district === "District 2" ? (
                      <>


                        <option value="City 2">Loharu</option>
                      </>
                    ) : null}
                    {district === "District A" ? (
                      <>

                        <option value="City A">Bajajnagar</option>
                        {/* <option value="City 2">Loharu</option> */}
                      </>
                    ) : district === "District B" ? (
                      <>
                        <option value="City B">Amber</option>

                      </>
                    ) : null}
                  </select>
                </div>
              )}

              <div className="form-group">
                <label>Caste</label>
                <select
                  className="form-control"
                  value={caste}
                  name="caste"
                  onChange={this.handleCasteChange}
                >
                  <option value="">{caste}</option>
                  <option value="Caste 1">Caste 1</option>
                  <option value="Caste 2">Caste 2</option>
                  {/* Add more options for caste */}
                </select>
              </div>

              {/* Subcaste dropdown */}
              {caste && (
                <div className="form-group">
                  <label>Subcaste</label>
                  <select
                    className="form-control"
                    value={subcaste}
                    name="subcaste"
                    onChange={this.handleSubcasteChange}
                  >
                    <option value="">{subcaste}</option>
                    {caste === "Caste 1" ? (
                      <>
                        <option value="Subcaste 1">Subcaste 1</option>
                        <option value="Subcaste 2">Subcaste 2</option>
                        {/* Add more options for subcaste 1 */}
                      </>
                    ) : caste === "Caste 2" ? (
                      <>
                        <option value="Subcaste A">Subcaste A</option>
                        <option value="Subcaste B">Subcaste B</option>
                        {/* Add more options for subcaste 2 */}
                      </>
                    ) : null}
                  </select>
                </div>
              )}

              {/* Gotra dropdown */}
              {subcaste && (
                <div className="form-group">
                  <label>Gotra</label>
                  <select
                    className="form-control"
                    value={gotra}
                    name="gotra"
                    onChange={this.handleGotraChange}
                  >
                    <option value="">{gotra}</option>
                    {/* Render options based on selected subcaste */}
                    {subcaste === "Subcaste 1" ? (
                      <>
                        <option value="Gotra 1">Gotra 1</option>
                        <option value="Gotra 2">Gotra 2</option>
                        {/* Add more options for gotra 1 */}
                      </>
                    ) : subcaste === "Subcaste 2" ? (
                      <>
                        <option value="Gotra X">Gotra X</option>
                        <option value="Gotra Y">Gotra Y</option>
                        {/* Add more options for gotra 2 */}
                      </>
                    ) : null}
                  </select>
                </div>
              )}
         <div className="form-group">
        <label htmlFor="occupation">Select Occupation</label>
        <select
          className={`form-control ${submeet && !selectedJobCategories.length && "parsley-error"}`}
          value={selectedJobCategories[0] || ""}
          name="selectedJobCategories"
          required
          onChange={this.handleOccupationChange}
        >
          <option value="">Select an occupation</option>
          {categoryData && categoryData.length > 0 && categoryData.map((item) => (
            <option key={item._id} value={item.name}>
              {item.name}
            </option>
          ))}
        </select>
        {submeet && !selectedJobCategories.length ? (
          <ul className="parsley-errors-list filled" id="parsley-id-29">
            <li className="parsley-required">Category is required.</li>
          </ul>
        ) : null}
      </div>

              <div className="form-group">
                <label>Kuldevi/Devata Name :</label>
                <input
                  className={`form-control ${!reg.test(kulName) && submeet && "parsley-error"
                    }`}
                  value={kulName}
                  name="kulName"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ kulName: e.target.value });
                  }}
                />
                {submeet && !reg.test(kulName) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="header">
                <h2>Business Profile</h2>
              </div>
              <div className="form-group">
                <label>Firm Name :</label>
                <input
                  className={`form-control ${!reg.test(firmName) && submeet && "parsley-error"
                    }`}
                  value={firmName}
                  name="firmName"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ firmName: e.target.value });
                  }}
                />
                {submeet && !reg.test(firmName) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Firm Address :</label>
                <input
                  className={`form-control ${!reg.test(firmAddress) && submeet && "parsley-error"
                    }`}
                  value={firmAddress}
                  name="firmAddress"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ firmAddress: e.target.value });
                  }}
                />
                {submeet && !reg.test(firmAddress) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label htmlFor="bloodGroup">Deals With :</label>
                <select
                  className={`form-control ${submeet && !dealsWith && "parsley-error"
                    }`}
                  value={dealsWith}
                  name="dealsWith"
                  required=""
                  onChange={(e) => {
                    this.setState({ dealsWith: e.target.value });
                  }}
                >
                  <option value="">{dealsWith}</option>
                  <option value="deal 1">Deal 1</option>
                  <option value="deal 2">Deal 2</option>

                </select>
                {submeet && !dealsWith ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">Deals With is required.</li>
                  </ul>
                ) : null}
              </div>




              <div className="form-group">
                <label>Website :</label>
                <input
                  className={`form-control ${!reg.test(website) && submeet && "parsley-error"
                    }`}
                  value={website}
                  name="website"
                  pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$"
                  required=""
                  type="website"
                  onChange={(e) => {
                    this.setState({ website: e.target.value });
                  }}
                />
                {submeet && !reg.test(website) ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
  <label>Image</label>

  {(this.state.imageInput.length > 0 ? this.state.currentImageUrls : this.state.existingImages).map((imageUrl, index) => (
    <div key={index}>
      <img
        src={`https://uma-classees.blr1.digitaloceanspaces.com/${imageUrl}`}
        alt={`Image ${index}`}
        style={{ width: '100px', marginBottom: '10px' }}
      />
    </div>
  ))}

  <input
    type="file"
    className={`form-control ${!this.state.imageInput.length && this.state.submeet && "parsley-error"}`}
    name="imageInput"
    multiple
    onChange={this.handleChangeMultipaleImages}
  />
  {!this.state.imageInput.length && this.state.submeet ? (
    <ul className="parsley-errors-list filled">
      <li className="parsley-required">This value is required.</li>
    </ul>
  ) : null}

  {this.state.errors.length > 0 && (
    <ul className="parsley-errors-list filled">
      {this.state.errors.map((error, index) => (
        <li key={index} className="parsley-required">{error}</li>
      ))}
    </ul>
  )}
</div>
              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <br />
            </form>
            <button
              className="btn btn-primary"
              onClick={(e) => {
                // this.setState({ submeet: true });
                this.handleSubmit(e)
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});
export default withRouter(EditDetails);
